<template>
  <div class="test-action" :class="{ 'is-embedded': embedded }">
    <template v-if="!isLoading">
      <header class="w-full !mb-4 flex items-center" v-if="showHeader">
        <div class="back" @click="handleBack">
          <UIcon name="arrow-left" />
        </div>

        <!-- <input type="text" class="title-test" v-model="test.title" placeholder="Введите название тест" /> -->
        <div class="w-full text-2xl">{{ isCreate ? 'Создание теста' : 'Изменение теста'}}</div>

        <div v-if="!isCreate" class="delete" @click="deleteTest">
          <UIcon name="delete" />
        </div>

        <UButton @click="actionTest" :loading="isSaving">
          {{ isCreate ? 'Создать тест' : 'Сохранить тест'}}
        </UButton>
      </header>

      <div class="content-test-action">
        <div class="settings !p-6 bg-white rounded-xl mr-4 min-w-[380px]">
          <div class="font-semibold	text-2xl mb-6">Настройки</div>

          <Input
            v-model="test.title"
            id="title"
            type="text"
            placeholder="Название"
            class="mb-16"
          />

          <FormTextarea
            v-model="test.description"
            id="description"
            type="text"
            label="Описание"
            class="mb-14"
          />

          <div class="timer mb-12 w-full">
            <div class="text-sm !mb-3 text-slate-400">Время на выполнение</div>

            <div class="flex w-full">
              <div class="flex bg-slate-100 w-1/3 !mr-3 block-bkg">
                <input type="text" v-model="timer.hour" class="w-full" />
                <div>час</div>
              </div>
              <div class="flex bg-slate-100 w-1/3 !mr-3 block-bkg">
                <input type="text" v-model="timer.min" class="w-full" />
                <div>мин</div>
              </div>
              <!-- <div @click="setNewTime" class="bg-blue-200 flex item-center justify-center w-1/3 flex items-center justify-center rounded-lg cursor-pointer">
                + 15
              </div> -->
            </div>
          </div>

          <div class="flex w-full">
            <div class="attempts w-[100px]">
              <div class="text-sm !mb-3 text-slate-400">Попытки</div>
              <input type="number" v-model="test.attempts" class="block-bkg w-full" />
            </div>

            <div class="!ml-4 w-[130px]">
              <div class="text-sm !mb-3 text-slate-400 whitespace-nowrap">Правильные ответы</div>
              <div class="flex block-bkg w-full">
                <input type="number" v-model="test.rightAnswer" class="w-full" />
                <div class="whitespace-nowrap text-gray-500">из {{ sizeQuestions }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="questions p-6 bg-white rounded-xl w-full">
          <div class="font-semibold	text-2xl mb-6">Вопросы</div>
          <QuestionsWrapper :questions="questions" @save="saveQuestions($event)" />
        </div>
      </div>
    </template>
    <UPreloader v-else />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { coreApi } from '@/api'
import UButton from '@/components/redesign/ui/UButton'
import UPreloader from '@/components/redesign/ui/UPreloader'
import Input from '@/components/redesign/form/FormInput';
import FormTextarea from '@/components/redesign/form/FormTextarea';
import QuestionsWrapper from "@/components/test/questions/QuestionsWrapper"

export default {
  name: 'TestPage',
  components: {
    UButton,
    UPreloader,
    Input,
    FormTextarea,
    QuestionsWrapper
  },
  props: {
    id: {
      type: [String, Number],
      default: 0,
    },
    isPage: {
      type: Boolean,
      default: false,
    },
    embedded: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isLoading: true,
      isSaving: false,
      timer: {
        hour: 0,
        min: 0,
      },
      test: {
        tags: [],
        rightAnswer: 0,
        attempts: 0,
      },
      questions: [],
    };
  },
  computed: {
    ...mapState('main', ['user']),
    isCreate() {
      return !(this.id > 0);
    },
    sizeQuestions() {
      return this.questions?.length || 0;
    },
    showHeader() {
      return this.isPage || this.embedded;
    },
  },
  methods: {
    async deleteTest() {
      await coreApi.testDelete(this.id);
      this.back();
    },
    handleBack() {
      if (this.embedded && !this.isPage) {
        this.$emit('cancel');
        return;
      }

      this.back();
    },
    back() {
      this.$router.replace(`/tests`);
    },
    async actionTest() {
      if (this.isSaving) return;

      this.isSaving = true;

      this.questions = this.questions.map((item) => {
        if (item.type === 'free') {
          item.answer = item.answers[0]
        }

        return item
      })

      this.test.timer = +this.timer.min + +this.timer.hour * 60;

      const dataParams = {
        user: this.user,
        questions: JSON.stringify(this.questions),
        test: this.test
      }

      try {
        let savedId = this.test.id;

        if (this.test.id) {
          await coreApi.testUpdate(dataParams)
        } else {
          const createdId = await coreApi.testCreate(dataParams)
          savedId = createdId?.id || createdId;
          this.test = {
            ...this.test,
            id: savedId,
          };
        }

        await this.refreshTestStores();

        const savedTest = await this.loadSavedTest(savedId);
        this.$emit('saved', {
          ...savedTest,
          type: 'test',
        });

        if (this.isPage) {
          if (this.$route.query.course) {
            this.$router.replace(`/course/${this.$route.query.course}`)
          } else {
            this.$router.replace(`/tests/`)
          }
        }
      } finally {
        this.isSaving = false;
      }
    },
    async refreshTestStores() {
      await Promise.all([
        this.$store.dispatch('main/getTests'),
        this.$store.dispatch('courses/getTests'),
      ]);
    },
    async loadSavedTest(id) {
      if (id > 0) {
        const test = await coreApi.test({ id });

        if (test?.id) return test;
      }

      return this.test;
    },
    async init() {
      this.isLoading = true;
      if (this.id  > 0) {
        let test = await coreApi.test({ id: this.id });

        if (test) {
          this.test = {
            ...test,
            questions: test.questions ? JSON.parse(test.questions) : []
          };

          this.timer.hour = Math.floor(test.timer/60);
          this.timer.min = test.timer - (this.timer.hour * 60);

          if (test.questions) {
            this.questions = JSON.parse(test.questions).map((item) => {
              return {
                ...item,
                isVissible: false,
                type: item.type || 'default'
              }
            })
          }
        } else {
          this.back();
        }
      }

      this.isLoading = false;
    },
    saveQuestions(data) {
      this.questions = data
    },
  },
  async mounted() {
    await this.init();
  },
};
</script>

<style lang="scss">
.test-action {
  width: 100%;

  & > header {
    .back,
    .delete {
      min-width: 48px;
      width: 48px;
      height: 48px;
      background: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 8px;
      margin-right: 16px;
      cursor: pointer;

      .icon {
        fill: #A9A9A9;
      }

      &:hover {
        .icon {
          fill: #777777;
        }
      }
    }

    .title-test {
      width: 100%;
      height: 48px;
      padding: 0 16px;
      background: #fff;
      border-radius: 8px;
      margin-right: 16px;
      cursor: pointer;
    }

    .button {
      height: 48px;
      max-width: 220px;
    }
  }

  .content-test-action {
    display: flex;
    align-items: flex-start;

    input {
      background: none;
    }

    .block-bkg {
      background: #F8F8F8;
      border-radius: 6px;
      height: 37px;
      display: flex;
      align-items: center;
      padding: 8px;
    }
  }

  &.is-embedded {
    padding: 28px 32px 24px;

    & > header {
      min-height: 52px;
      margin-bottom: 28px !important;
      padding-right: 54px;

      .back {
        background: transparent;
        margin-right: 20px;
      }

      .w-full.text-2xl {
        font-weight: 600;
        font-size: 24px;
        line-height: 30px;
      }

      .button {
        flex: 0 0 230px;
        max-width: 230px;
        height: 52px;
      }
    }

    .content-test-action {
      display: grid;
      grid-template-columns: minmax(280px, 340px) minmax(0, 1fr);
      gap: 28px;
      align-items: start;

      .settings,
      .questions {
        background: transparent !important;
        border-radius: 0 !important;
        padding: 0 !important;
        margin-right: 0 !important;
      }

      .settings {
        min-width: 0 !important;

        .font-semibold {
          font-size: 22px;
          line-height: 28px;
          margin-bottom: 32px !important;
        }

        .form-input,
        .form-textarea {
          margin-bottom: 36px !important;
        }

        .timer {
          margin-bottom: 32px !important;
        }
      }

      .questions {
        width: 100%;

        & > .font-semibold {
          font-size: 22px;
          line-height: 28px;
          margin-bottom: 32px !important;
        }
      }

      .questions-list {
        .button-group {
          position: static;
          margin-top: 16px;
        }
      }
    }

    @media (max-width: 992px) {
      padding: 20px 8px 8px;

      & > header {
        flex-wrap: wrap;
        gap: 12px;
        padding-right: 44px;

        .w-full.text-2xl {
          order: 2;
          flex-basis: 100%;
        }

        .button {
          flex: 1 1 190px;
          max-width: none;
        }
      }

      .content-test-action {
        display: flex;
        flex-direction: column;
      }
    }
  }
}
</style>
